import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { PDFViewer, pdf } from "@react-pdf/renderer";
import PurDispatchData from '../data/PurDispatchData';
import QuotationDocument from '../components/PurDispatchDocumentFormat/PurDispatchDocument';
import { Box, CircularProgress, Typography, Button, Tooltip, Menu, MenuItem, ListItemIcon, } from "@mui/material";
import axios from 'axios';
import { Email, WhatsApp } from "@mui/icons-material";
import ShareIcon from "@mui/icons-material/Share";

const PurDispatchViewPage = ({ loggedInUser, companyData, connectionString }) => {
    const path = connectionString;
    const { challanId } = useParams();
    const [quota, setQuota] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    console.log("companyId: ", companyData);
    const companyId = companyData?.[0]?.CompId;
    const company = Array.isArray(companyData) ? companyData[0] : companyData;

    useEffect(() => {
        const fetch = async () => {
            try {
                const data = await PurDispatchData(challanId, connectionString, companyId);
                setQuota(data);
            } catch (err) {
                setError("Failed to load challan.");
            } finally {
                setLoading(false);
            }
        };
        fetch();
    }, [challanId]);

    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    // ? Unified share/download logic
    const sharePDF = async (quota, target = "whatsapp") => {
        try {
            const blob = await pdf(<QuotationDocument quota={quota} loggedInUser={loggedInUser} companyData={companyData} connectionString={connectionString} />).toBlob();

            // ? Filename: QuotationNo_FirmName.pdf
            const safeFirmName = quota.companyName.replace(/[^a-z0-9]/gi, "_");
            const fileName = `${quota.invoiceNo}_${safeFirmName}.pdf`;

            const file = new File([blob], fileName, { type: "application/pdf" });

            // 1?? If sharing to WhatsApp and navigator.share is supported ? Direct Share
            if (target === "whatsapp" && navigator.canShare && navigator.canShare({ files: [file] })) {
                await navigator.share({
                    title: `Challan ${quota.challanNo}`,
                    text: `Please check the attached quotation for ${quota.companyName}`,
                    files: [file],
                });
                return;
            }

            // 2?? If File System Access API available ? Save As dialog
            if (window.showSaveFilePicker) {
                const handle = await window.showSaveFilePicker({
                    suggestedName: fileName,
                    types: [{ description: "PDF Document", accept: { "application/pdf": [".pdf"] } }],
                });
                const writable = await handle.createWritable();
                await writable.write(blob);
                await writable.close();
                alert(`? Saved locally as ${fileName}`);
                return;
            }

            const formData = new FormData();

            // 3) POST the form data to the backend
            const response = await axios.post(`${path}/api/send-dispatch`, formData, { headers: { 'Content-Type': 'multipart/form-data' }, });

            console.log('[sendChallanToBackend] Upload success:', response.data);
            alert('Quota sent to backend!');

            // 3?? Fallback ? force browser download
            const url = URL.createObjectURL(file);
            const a = document.createElement("a");
            a.href = url;
            a.download = fileName;
            a.click();
            URL.revokeObjectURL(url);

            if (target === "whatsapp") {
                alert(`?? PDF downloaded as ${fileName}.\nAttach it manually in WhatsApp chat.`);
            } else if (target === "email") {
                window.location.href = `mailto:${quota.toEmail}?subject=Quotation ${quota.invoiceNo}&body=Please find attached quotation PDF.`;
            }
        } catch (err) {
            console.error("Share failed:", err);
            alert("Failed to share PDF.");
        }
    };

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <Box p={4}>
                <Typography color="error">{error}</Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ position: "relative", width: "100%", height: "100vh" }}>
            <Tooltip title="Share" arrow>
                <Button
                    onClick={handleClick}
                    sx={{
                        position: "fixed",
                        top: 18,
                        right: 165,
                        zIndex: 10,
                        minWidth: 38,
                        height: 38,
                        borderRadius: "50%",
                        "&:hover": {
                            bgcolor: "grey.700",
                            boxShadow: "0 0 12px 3px white",
                        },
                    }}
                >
                    <ShareIcon sx={{ fontSize: 22, color: "white" }} />
                </Button>
            </Tooltip>

            {/* Dropdown Menu */}
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                <MenuItem
                    onClick={() => {
                        handleClose();
                        sharePDF(quota, "whatsapp");
                    }}
                    sx={{ "&:hover": { bgcolor: "rgba(37, 211, 102, 0.1)" } }}
                >
                    <ListItemIcon>
                        <WhatsApp sx={{ color: "#25D366" }} />
                    </ListItemIcon>
                    WhatsApp
                </MenuItem>

                <MenuItem
                    onClick={() => {
                        handleClose();
                        sharePDF(quota, "email");
                    }}
                    sx={{ "&:hover": { bgcolor: "rgba(234, 67, 53, 0.1)" } }}
                >
                    <ListItemIcon>
                        <Email sx={{ color: "#EA4335" }} />
                    </ListItemIcon>
                    Email
                </MenuItem>
            </Menu>

            {/* PDF Viewer */}
            <Box sx={{ width: "100%", height: "100%" }}>
                <PDFViewer width="100%" height="100%">
                    <QuotationDocument quota={quota} loggedInUser={loggedInUser} companyData={company} connectionString={connectionString} />
                </PDFViewer>
            </Box>
        </Box>
    );
};

export default PurDispatchViewPage;




// // Import required React hooks and components
// import { useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';
// import { PDFViewer, pdf } from '@react-pdf/renderer';
// import PurDispatchData from '../data/PurDispatchData'; // Function to fetch quotation info
// import QuotationDocument from '../components/PurDispatchDocumentFormat/PurDispatchDocument'; // PDF document component
// import { Box, CircularProgress, Typography, Button, Stack, Tooltip, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
// import axios from 'axios';
// import { Email, WhatsApp } from "@mui/icons-material"; // you can also use react-icons if preferred
// import ShareIcon from "@mui/icons-material/Share";

// // Base URL for API requests
// // const path = 'http://192.168.1.248:3107';

// const PurDispatchViewPage = ({ loggedInUser, companyData, connectionString }) => {
//     const path = connectionString; // Use the connection string passed as a prop
//     // Get challanId from the URL route parameters
//     const { challanId } = useParams();

//     // State to store fetched quotation data
//     const [quota, setquota] = useState(null);

//     // State to manage loading and error
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState();

//     const [anchorEl, setAnchorEl] = useState(null);
//     const open = Boolean(anchorEl);

//     const handleClick = (event) => {
//         setAnchorEl(event.currentTarget);
//     };
//     const handleClose = () => {
//         setAnchorEl(null);
//     };

//     // Fetch the quotation data when the component mounts or when challanId changes
//     useEffect(() => {
//         const fetch = async () => {
//             try {
//                 console.log('[PurDispatchViewPage] Fetching quota data…', challanId);
//                 const data = await PurDispatchData(challanId, connectionString); // API call or local logic
//                 console.log('[PurDispatchViewPage] Fetched quota:', data);
//                 setquota(data);
//             } catch (err) {
//                 console.error('[PurDispatchViewPage] Error:', err);
//                 setError('Failed to load quota.');
//             } finally {
//                 setLoading(false); // End loading state
//             }
//         };
//         fetch(); // Call fetch function
//     }, [challanId]);

//     // Function to generate PDF and send it to backend
//     const sendChallanToBackend = async (quota) => {
//         try {
//             // 1) Generate a PDF Blob from the React component (QuotationDocument)
//             const blob = await pdf(<QuotationDocument quota={quota} />).toBlob();

//             // 2) Create a FormData object to simulate file upload
//             const fileName = `${quota.challanNo}_${quota.companyName}.pdf`;
//             const formData = new FormData();

//             formData.append('pdf', blob, fileName);                  // Attach PDF blob
//             formData.append('companyName', quota.companyName);       // Company Name
//             formData.append('challanNo', quota.challanNo);     // Quotation No
//             formData.append('mobileNo', quota.mobileNo);             // Mobile No
//             formData.append('toEmail', quota.toEmail);               // Email to send

//             // Debug: Log FormData fields
//             for (let [key, val] of formData.entries()) {
//                 console.log(`FormData ${key}:`, val);
//             }

//             // 3) POST the form data to the backend
//             const response = await axios.post(`${path}/api/send-dispatch`, formData, { headers: { 'Content-Type': 'multipart/form-data' }, });

//             console.log('[sendChallanToBackend] Upload success:', response.data);
//             alert('Quota sent to backend!');
//         } catch (error) {
//             console.error('[sendChallanToBackend] Error:', error);
//             alert('Failed to send quota.');
//         }
//     };

//     // Show loader while data is being fetched
//     if (loading) {
//         return (
//             <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
//                 <CircularProgress />
//             </Box>
//         );
//     }

//     // Display error if data fetch fails
//     if (error) {
//         return (
//             <Box p={4}>
//                 <Typography color="error">{error}</Typography>
//             </Box>
//         );
//     }

//     // Render the PDF and the Send button
//     return (
//         <Box sx={{ position: 'relative', width: '100%', height: '100vh' }}>
//             {/* Floating button to send the quotation to the backend via email */}
//             {/* <Button
//                 variant="contained"
//                 color="primary"
//                 onClick={() => sendChallanToBackend(quota)}
//                 sx={{ position: 'fixed', top: 10, right: 16, zIndex: 10 }}
//             >
//                 Send to User
//             </Button> */}

//             <Tooltip title="Share" arrow>
//                 <Button onClick={handleClick}
//                     sx={{
//                         position: "fixed", top: 18, right: 165, zIndex: 10, minWidth: 38, height: 38, borderRadius: "50%",
//                         // bgcolor: "primary.main",
//                         "&:hover": {
//                             bgcolor: "grey.700",
//                             boxShadow: "0 0 12px 3px white"
//                         }
//                     }}
//                 >
//                     <ShareIcon sx={{ fontSize: 22, color: "white" }} />
//                 </Button>
//             </Tooltip>
//             <Menu anchorEl={anchorEl} open={open} onClose={handleClose}
//                 PaperProps={{
//                     sx: { mt: 1, borderRadius: 3, bgcolor: "transparent", boxShadow: "0px 4px 20px rgba(0,0,0,0.15)", }
//                 }}
//             >
//                 <MenuItem sx={{ "&:hover": { bgcolor: "rgba(37, 211, 102, 0.1)" } }}
//                     onClick={() => {
//                         handleClose();
//                         sendChallanToBackend(quota, "whatsapp");
//                     }}
//                 >
//                     <ListItemIcon>
//                         <WhatsApp sx={{ color: "#25D366" }} />
//                     </ListItemIcon>
//                 </MenuItem>

//                 <MenuItem sx={{ "&:hover": { bgcolor: "rgba(234, 67, 53, 0.1)" } }}
//                     onClick={() => {
//                         handleClose();
//                         sendChallanToBackend(quota, "email");
//                     }}
//                 >
//                     <ListItemIcon>
//                         <Email sx={{ color: "#EA4335" }} />
//                     </ListItemIcon>
//                 </MenuItem>
//             </Menu>

//             {/* Display the PDF using PDFViewer (full height/wchallanIdth) */}
//             <Box sx={{ width: '100%', height: '100%' }}>
//                 <PDFViewer width="100%" height="100%">
//                     <QuotationDocument quota={quota} loggedInUser={loggedInUser} companyData={companyData} />
//                 </PDFViewer>
//             </Box>
//         </Box>
//     );
// };

// export default PurDispatchViewPage;